/* app/js/src/components/clipping-studio/panels/graphics-panel/graphic-card/clipping-studio-graphic-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  min-width: 0;
}
.graphic-card__preview-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
}
.graphic-card__preview-inner--logo,
.graphic-card__preview-inner--fruit-icon,
.graphic-card__preview-inner--emoji {
  align-items: center;
  justify-content: center;
}
.graphic-card__logo-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}
.graphic-card__logo-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.graphic-card__logo-initials {
  color: rgb(255, 255, 255);
  font-size: 14px;
  font-weight: 800;
  font-family: "Open Sans", sans-serif;
  letter-spacing: 0.05em;
}
.graphic-card__emoji-preview {
  font-size: 2.5rem;
  line-height: 1;
  -webkit-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=clipping-studio-graphic-card.component.css.map */
